function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export default function componentStyleOverrides(color) {
  return {
    MuiButton: {
      styleOverrides: {
        root: function root(_ref) {
          var ownerState = _ref.ownerState;
          return {
            boxShadow: 'none',
            '&:hover': _objectSpread({
              boxShadow: 'none'
            }, ownerState.color === 'neutral' && {
              color: color.primary.main,
              fontWeight: 700
            })
          };
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          '.MuiFormLabel-asterisk': {
            color: color.error.main
          }
        }
      }
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          '.MuiTableRow-root:hover': {
            '.MuiTableCell-root:not(.cx-table-empty-td)': {
              backgroundColor: color.table.row.hoverColor
            }
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          background: color.background.paper,
          borderColor: color.table.cell.borderColor
        },
        head: {
          backgroundColor: color.table.head.backgroundColor,
          color: color.table.head.color,
          fontSize: '12px',
          height: '28px',
          paddingTop: '0 !important',
          paddingBottom: '0 !important'
        }
      }
    },
    MuiMenu: {
      defaultProps: {
        elevation: 0
      }
    },
    MuiPaper: {
      defaultProps: {
        elevation: 1
      },
      styleOverrides: {
        root: function root(_ref2) {
          var ownerState = _ref2.ownerState;
          return _objectSpread(_objectSpread(_objectSpread({}, ownerState.elevation === 0 && {
            backgroundColor: color.background.paper0
          }), ownerState.elevation === 2 && {
            backgroundColor: color.background.paper2
          }), {}, {
            backgroundImage: 'none'
          });
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: color.background.chip,
          borderColor: color.divider
        },
        label: {
          color: color.text.secondary,
          padding: '0 14px',
          fontSize: '14px'
        }
      }
    },
    MuiAppBar: {
      defaultProps: {
        elevation: 1
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: color.primary.main
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: color.divider
          }
        }
      }
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true
      },
      styleOverrides: {
        tooltip: {
          color: color.text.primary,
          backgroundColor: color.background.paper0,
          boxShadow: ' 0px 0px 20px 0px rgba(0,0,0,0.1)',
          padding: '16px',
          maxWidth: '600px',
          lineHeight: '22px',
          fontSize: '14px'
        },
        arrow: {
          color: color.background.paper0
        }
      }
    }
  };
}